import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#056DAE",
    },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: "futura-pt, sans-serif",
    fontWeightLight: 200,
    fontWeightRegular: 300,
    fontWeightMedium: 400,
    fontWeightBold: 500,
    useNextVariants: true,
    h1: {
      fontFamily: "futura-pt, sans-serif",
      fontSize: "4.25rem",
      color: "#26a69a",
    },
    h2: {
      fontSize: "2.625rem",
      color: "#333333",
    },
    h3: {
      fontSize: "1.625rem",
      color: "#333333",
    },
    h4: {
      fontSize: "1.3125rem",
      color: "#333333",
    },
    h5: {
      fontSize: "1.0rem",
      color: "#333333",
    },
    h6: {
      fontSize: "1.0rem",
    },
    body1: {
      fontSize: "1.0rem",
      fontWeight: 100,
    },
    button: {
      fontFamily: "futura-pt, sans-serif",
      fontSize: "1.0rem",
      textTransform: "none",
    },
  },
  overrides: {
    MuiButton: {
      containedPrimary: {
        backgroundColor: "rgba(5,109,174,1.0)",
        "&:hover": {
          backgroundColor: "rgba(5,109,174,0.75)",
        },
      },
    },
  },
});
